module.exports = __webpack_public_path__ + "static/dog-walking-5d61aca49e96fc26c3ade4e3d6f2231c.png";